import ApplicationCooLayout from '../../../layout/application-coo-layout';
import { TextSubheader } from '../../../components/text/text-subheader';
import { P2Button } from 'react-bootstrap-common-script';
import { useNavigate } from 'react-router-dom';
import { useInitialWindowScrollTo } from '../../../hooks/use-initial-window-scroll-to';
import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/hook';

/** Return URL after AC28 posts to POLYMER valuation-fee payment-success. */
const StageDValuationFeeSuccess = () => {
  useInitialWindowScrollTo();
  const navigate = useNavigate();
  const applicationId = useAppSelector((state) => state.app.ApplicationIdSlice.applicationId);
  const queryParameters = new URLSearchParams(window.location.search);
  const applicationIdParam = queryParameters.get('application_id');

  const applicationUuid = useMemo(() => applicationIdParam ?? applicationId ?? '', [applicationIdParam, applicationId]);

  return (
    <ApplicationCooLayout>
      <div className='view-application-stage-d-container'>
        <TextSubheader subheaderMain='Payment received' subheaderSub='Valuation fee' />
        <p className='mt-4'>
          Thank you for the valuation fee payment. A HDB appointed valuer will contact the owners to perform the valuation of the flat within the next 2 weeks.
        </p>
        <P2Button
          variant='primary'
          className='mt-3'
          onClick={() => navigate(`/application-coo/stage-d/in-principle-approval?application_id=${applicationUuid}`)}>
          Back to application
        </P2Button>
      </div>
    </ApplicationCooLayout>
  );
};

export default StageDValuationFeeSuccess;
